import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./recipient-filter.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./recipient-filter.component.scss?ngResource";
import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from "@angular/core";
import { AppControllerService } from "../../../../../app-controller.service";
import { RecipientService } from "../shared-services/recipient.service";
import { CRUDOperation } from "../../../../models/crud-operation-enum.model";
import { take } from "rxjs/operators";
import { AlertType } from "../../../../models/alert";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AddRecipientModalComponent } from "../modal-components/add-recipient-modal/add-recipient-modal.component";
import { RecipientFormConstants } from "../shared-contants/recipient-shared.constants";
import { RecipientFilterConstants } from "./recipient-filter.constants";
import { AutoUnsubPortal } from "../../../../decorators/autounsub-portal.decorator";
let RecipientFilterComponent = class RecipientFilterComponent {
    appControllerService;
    recipientFilterService;
    modalService;
    changeDetectorRef;
    disableAddRecipientBtn;
    configurableLabel;
    isUsedInRecipientSelect = true;
    jobId;
    formName;
    loadAllRecipientsEventEmitted = new EventEmitter();
    loadRecipientEventEmitted = new EventEmitter();
    groupsOptions = [];
    stepMetaGroups = [];
    // Labels
    displayGroupsLabel = RecipientFilterConstants.displayGroupsLabel;
    selectGroupsLabel = RecipientFilterConstants.selectGroupsLabel;
    selectAllFromGroupBtnLabel = RecipientFilterConstants.selectAllFromGroupBtnLabel;
    selectedGroupsFromDropdown;
    selectedGroupOptions = ["All"];
    selectedRecipientFromDropdown;
    selectedRecipientOptions = [];
    displayFilterGroups;
    showSelectRecipientBtn = false; // only show filter is attached to recipient-list
    recipientsFromDb = [];
    showSelectAllRecipientsBtn = true;
    AddOrSelectRecipientLabel = "Select recipient";
    displayAddButton = true;
    displayGroupsChecked;
    addRecipientBtnLabel = "Add recipient"; // configurable variable
    componentName = RecipientFilterConstants.componentName;
    moduleId;
    recipientGroupsFromMetadata;
    getRecipientsByGroupSubscription;
    constructor(appControllerService, recipientFilterService, modalService, changeDetectorRef) {
        this.appControllerService = appControllerService;
        this.recipientFilterService = recipientFilterService;
        this.modalService = modalService;
        this.changeDetectorRef = changeDetectorRef;
        this.moduleId = Number(this.appControllerService.selectedModuleID);
    }
    ngOnChanges(changes) {
        if (changes && changes.hasOwnProperty("stepMetaGroups") && changes.stepMetaGroups.currentValue && changes.stepMetaGroups.currentValue.length > 0) {
            const groups = changes.stepMetaGroups.currentValue;
            this.recipientGroupsFromMetadata = groups;
            this.getRecipients(groups);
        }
    }
    ngOnInit() {
        this.showOrRemoveFilterButtons();
    }
    onDisplayGroupsChangedChecked($event) {
        const displayGroupsChecked = $event.target.checked;
        if (displayGroupsChecked) {
            this.displayFilterGroups = true;
            this.selectedRecipientOptions.sort((a, b) => (a.consolidatedGroup?.localeCompare(b.consolidatedGroup)));
        }
        else {
            this.displayFilterGroups = false;
            this.selectedRecipientOptions.sort((a, b) => (a.name?.localeCompare(b.name)));
        }
    }
    onSelectGroupsChanged($event) {
        // triggered by checkbox from recipient select filter
        const groupSelected = $event.target.value;
        this.filterRecipients(groupSelected);
    }
    onSelectRecipientBtnClicked() {
        this.loadRecipients();
    }
    onSelectedRecipientChanged() {
        if (this.isUsedInRecipientSelect) {
            this.loadRecipients();
        }
    }
    loadRecipients() {
        if (this.selectedRecipientFromDropdown !== undefined) {
            this.loadRecipientEventEmitted.emit(this.selectedRecipientFromDropdown);
        }
        else {
            this.appControllerService.showMessage("Please make a selection from the drop down before adding", AlertType.Warning);
        }
    }
    onSelectAllFromGroupBtnClicked() {
        if (this.selectedRecipientOptions.length > 0) {
            this.loadAllRecipientsEventEmitted.emit(this.selectedRecipientOptions);
        }
    }
    onAddRecipientBtnClicked() {
        const modalRef = this.modalService.open(AddRecipientModalComponent, RecipientFormConstants.modalBodyOptions);
        modalRef.componentInstance.dialogTitle = this.configurableLabel ? `Add ${this.configurableLabel}` : `Add recipient`;
        modalRef.componentInstance.configurableLabel = this.configurableLabel ? `${this.configurableLabel} details` : `Add recipient`;
        modalRef.componentInstance.moduleId = +this.moduleId;
        modalRef.componentInstance.groupsOptions = this.groupsOptions;
        modalRef.componentInstance.jobId = +this.jobId;
        modalRef.componentInstance.groupsFromMetadata = this.recipientGroupsFromMetadata;
        if (this.recipientGroupsFromMetadata.length > 1) {
            modalRef.componentInstance.showRecipientsGroupsDropdown = true;
        }
        else {
            modalRef.componentInstance.showRecipientsGroupsDropdown = false;
        }
        modalRef.result.then((newRecipient) => {
            if (newRecipient) {
                this.recipientsFromDb.push(newRecipient);
                newRecipient.fullName = `${newRecipient.name} ${newRecipient.surname}`;
                newRecipient.consolidatedGroup = this.createConsolidatedGroups(newRecipient);
                this.selectedRecipientOptions.push(newRecipient);
                this.selectedRecipientOptions.sort((a, b) => (a.name?.localeCompare(b.name)));
                this.loadRecipientEventEmitted.emit(newRecipient);
            }
        });
    }
    getRecipients(recipientGroups) {
        if (recipientGroups && recipientGroups.length > 0) {
            this.getRecipientsByGroupSubscription =
                this.recipientFilterService.getRecipientsByGroup(this.generateFilterObject(recipientGroups)).pipe(take(1)).subscribe({
                    next: (recipients) => {
                        if (recipients.recipients.length > 0) {
                            this.recipientsFromDb = recipients.recipients;
                            this.populateGroupsDropDown();
                            this.populateRecipientsDropDown();
                            this.configureFilterComponent();
                            this.changeDetectorRef.detectChanges();
                        }
                    },
                    error: (error) => {
                        this.appControllerService.handleServerErrorMessage(this.componentName, error, CRUDOperation.Add);
                    }
                });
        }
    }
    configureFilterComponent() {
        if (this.isUsedInRecipientSelect) {
            this.configureForRecipientSelect();
        }
        if (!this.isUsedInRecipientSelect) {
            this.configureForRecipientList();
        }
    }
    setConfigurableLabel(addOrSelectText) {
        const textLabel = this.configurableLabel;
        if (textLabel !== undefined && textLabel !== "") {
            this.addRecipientBtnLabel = `${addOrSelectText} ${textLabel}`[0].toUpperCase() + `${addOrSelectText} ${textLabel}`.substr(1).toLowerCase();
            this.AddOrSelectRecipientLabel = `Select ${textLabel.toLowerCase()}`;
        }
        else {
            this.isUsedInRecipientSelect ? this.addRecipientBtnLabel = "Add recipient" : this.addRecipientBtnLabel = "Select recipient";
        }
    }
    configureForRecipientSelect() {
        this.showOrRemoveFilterButtons();
        this.setConfigurableLabel("Add");
    }
    configureForRecipientList() {
        this.showOrRemoveFilterButtons();
        this.setConfigurableLabel("Select");
    }
    showOrRemoveFilterButtons() {
        if (this.isUsedInRecipientSelect) {
            // show recipient select button configuration
            this.showSelectRecipientBtn = false; // removes the selectRecipient button into the viewer
            this.showSelectAllRecipientsBtn = false; // removes the selectAllRecipient button into the viewer
            if (this.disableAddRecipientBtn) {
                this.displayAddButton = false; // adds the addRecipient button from the viewer
            }
        }
        else {
            // show recipient list button configuration
            this.showSelectRecipientBtn = true; // adds the selectRecipient button into the viewer
            this.showSelectAllRecipientsBtn = true; // add the selectAllRecipient button into the viewer
            this.displayAddButton = false; // removes the add recipient button , should only be shown on the recipient select
        }
    }
    generateFilterObject(recipientGroups) {
        const recipientSelect = {
            jobId: this.jobId,
            moduleId: this.moduleId,
            groups: []
        };
        if (recipientGroups.length > 0) {
            recipientGroups.forEach((group, i) => {
                const ggroup = {
                    groupType: group.groupType,
                    groupName: group.groupName
                };
                recipientSelect.groups.push(ggroup);
            });
        }
        return recipientSelect;
    }
    populateGroupsDropDown() {
        this.groupsOptions = [];
        this.recipientGroupsFromMetadata.forEach(group => {
            this.groupsOptions.push(group.groupName);
            this.selectedGroupOptions.push(group.groupName);
        });
        this.groupsOptions.sort((a, b) => (a?.localeCompare(b)));
    }
    createConsolidatedGroups(recipient) {
        const groups = [];
        recipient.groups?.forEach(group => groups.push(group.groupName));
        return groups.join(", ");
    }
    filterRecipients(groupSelected) {
        this.selectedRecipientOptions = [];
        if (groupSelected === "All") {
            this.selectedRecipientOptions = this.recipientsFromDb;
        }
        else {
            this.selectedRecipientOptions = this.recipientsFromDb.filter((recipient) => {
                for (const recipientGroup of recipient.groups) {
                    if (recipientGroup.groupName === groupSelected) {
                        return recipient;
                    }
                }
            });
        }
        this.sortGroupsAlphabetically();
        this.selectedRecipientFromDropdown = this.selectedRecipientOptions[0];
        this.changeDetectorRef.detectChanges();
    }
    sortGroupsAlphabetically() {
        if (this.displayFilterGroups) {
            this.selectedRecipientOptions.sort((a, b) => (a.consolidatedGroup?.localeCompare(b.consolidatedGroup)));
        }
        else {
            this.selectedRecipientOptions.sort((a, b) => (a.name?.localeCompare(b.name)));
        }
    }
    populateRecipientsDropDown() {
        this.recipientsFromDb.forEach(recipient => {
            recipient.consolidatedGroup = this.createConsolidatedGroups(recipient);
            this.selectedRecipientOptions.push(recipient);
        });
    }
    static ctorParameters = () => [
        { type: AppControllerService },
        { type: RecipientService },
        { type: NgbModal },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        disableAddRecipientBtn: [{ type: Input }],
        configurableLabel: [{ type: Input }],
        isUsedInRecipientSelect: [{ type: Input }],
        jobId: [{ type: Input }],
        formName: [{ type: Input }],
        loadAllRecipientsEventEmitted: [{ type: Output }],
        loadRecipientEventEmitted: [{ type: Output }],
        groupsOptions: [{ type: Input }],
        stepMetaGroups: [{ type: Input }]
    };
};
RecipientFilterComponent = __decorate([
    Component({
        selector: "app-recipient-filter",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], RecipientFilterComponent);
export { RecipientFilterComponent };
